import Axios from 'axios';  // Import Axios for making HTTP requests
import { toast } from 'react-toastify';  // Import toast notifications from react-toastify
import { decryptResponse } from '../Components/Utility';
import { auth } from '../Components/firebase/firebase';
import { Logmeout, IS_PROD } from '../Components/Constants';

// Create an Axios instance with custom default headers
const axios = Axios.create({
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-store, max-age=0',
    'X-Content-Type-Options': 'nosniff',
    'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
    'X-XSS-Protection': '1; mode=block',
    'Content-Security-Policy': "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline'; img-src 'self' data:; connect-src 'self'; font-src 'self'; object-src 'none'; frame-ancestors 'none'; base-uri 'self'; form-action 'self'",
    'X-Frame-Options': 'DENY',
    'Referrer-Policy': 'strict-origin-when-cross-origin',
    'Permissions-Policy': 'geolocation=(), microphone=(), camera=()',
    'Cross-Origin-Opener-Policy': 'same-origin',
    'Cross-Origin-Resource-Policy': 'same-origin',
    'Cross-Origin-Embedder-Policy': 'require-corp',
  }
});

// Add the "X-Status" header only if in production
if (IS_PROD) {
  axios.defaults.headers["X-Status"] = "web";
}

// Function to retrieve the access token from session storage
const getAccessToken = async () => {
  const token = await auth?.currentUser?.getIdToken();
  return token
}
// Add a request interceptor to include the access token in the Authorization header
axios.interceptors.request.use(async (config) => {
  const newToken = await getAccessToken();
  const token = `Bearer ${newToken}`;
  config.headers.Authorization = token;

  // Remove double slashes in URL except after protocol
  if (config.url) {
    config.url = config.url.replace(/([^:]\/)\/+/g, "$1");
  }

  return config;
});

// Add a response interceptor to handle errors
axios.interceptors.response.use(
  async (response) => {
    if (
      response.status === 200 &&
      response.headers["content-type"] === "text/plain"
    ) {
      response.data = decryptResponse(response.data);

    } else if (response.status === 401) {
      alert("Session Expired , Please Login Again")
      await Logmeout(auth);
    }
    return response;
  },

  error => {
    toast.info('Request failed. Please check your connection and retry!');  // Display an info toast on error
    return Promise.reject(error);  // Reject the promise with the error
  }
);

export default axios;  // Export the configured Axios instance
